import Map from '../bundles/event_design/components/map';
import WebpackerReact from 'webpacker-react';

WebpackerReact.setup({ Map });
